import { render, staticRenderFns } from "./UserCardList.vue?vue&type=template&id=87b3da6c&scoped=true&"
import script from "./UserCardList.vue?vue&type=script&lang=js&"
export * from "./UserCardList.vue?vue&type=script&lang=js&"
import style0 from "./UserCardList.vue?vue&type=style&index=0&id=87b3da6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b3da6c",
  null
  
)

export default component.exports